<script>
// import axios from "axios";
import Vue from 'vue'
import DatePicker from "vue2-datepicker";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import tableReports from "@/components/widgets/tableReports";
import { todoMethods, todoComputed } from "@/state/helpers";
import { tableData } from "./dataAdvancedtable";
import { getReport } from "../../../helpers/getReports";
import axios from 'axios';
import moment from 'moment';
var XLSX = require("xlsx");
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
Vue.use(VueSweetalert2);

/**
 * Dashboard Component
 */
export default {
	page: {
		title: "Reportes",
		meta: [
			{
				name: "description",
				content: appConfig.description,
			},
		],
	},
	components: {
		Layout,
		PageHeader,
		tableReports,
		DatePicker
	},
	data() {
		return {

// ************************************** Link
			tableData: tableData,
			title: "Reportes",
			items: [
				{
					text: "Escritorio",
					href: "/",
				},
				{
					text: "Reportes",
					active: true,
				},
			],
			tableReports: [],
			itemsTable:[],
			showModal: false,
			isLoading: false,
			fullPage: true,
			canCancel: false,
			totalRows: 1,
			todoTotalRows: 1,
			currentPage: 1,
			todocurrentPage: 1,
			perPage: 10,
			todoperPage: 10,
			pageOptions: [10, 25, 50, 100],
			todoOptions: [10, 50, 100, 150, 200],
			filter: null,
			todoFilter: null,
			filterOn: [],
			todofilterOn: [],
			sortBy: "age",
			sortDesc: false,
			useSlot: false,
			loader: "spinner",
			color: "#007bff",
			bgColor: "#FFFFFF",
			height: 128,
			width: 128,
			timeout: 3000, //ms
			fetchingStats: true,
			earningStatus: true,
			reporte:'',
			url:'',
			urlDownload:'',
			getObject:{},
			daterange:[null,null],
			negocioSelect:false,
			puntoSelect:false,
			municipioSelect:false,
			negocios:[],
			puntos:[],
			municipios:[],
			negocioSelected:'',
			puntoSelected:'',
			municipioSelected:'',
			token:localStorage.getItem('token'),
			permit: '',
			id_empresa: '',
			id_negocio: '',
			id_usuario: '',
			id_user_municipio: '',
			options: [],

		};
	},

	computed: {
		...todoComputed,
		/**
		 * Total no. of records
		 */
		rows() {
			return this.tableData.length;
		},

		/**
		 * Todo list of records
		 */
		todoList() {
			return this.todos.length;
		},
	},

	mounted() {

		this.getOptions();

		this.fetchTodos();
		// Set the initial number of items
		this.totalRows = this.tableData.length;

		this.todoTotalRows = this.todos.length;

		setTimeout(() => {
			this.showModal = true;
		}, 1500);
	},

		methods: {
		...todoMethods,

		getOptions(){
			const permit = localStorage.getItem("permits");
			if(permit){
				const jsonUser = JSON.parse(localStorage.getItem("user"));
				const jsonPermit = JSON.parse(permit);
				this.permit = jsonPermit.permit;
				this.id_empresa = jsonUser.id_empresa;
				if (jsonPermit.permit === 'gerente') {
					this.id_negocio = jsonUser.id_negocio;
				}
				if(jsonPermit.permit == 'empresa'){
					this.options = [
						"REPORTE GENERAL",
					];
				} else if(jsonPermit.permit == 'negocio'){
					this.options = [
						"REPORTE POR PUNTO DE VENTA",
						"REPORTE GENERAL PARA NEGOCIOS"
					];
				}else if(jsonPermit.permit === 'gerente'){
					this.options = [
						"REPORTE POR PUNTO DE VENTA",
						"REPORTE PARA NEGOCIOS"
					];
				}else if(jsonPermit.permit === 'admin_municipio'){
					this.options = [
						"REPORTE GENERAL",
						"REPORTE DE VENTAS",
						"REPORTE POR USO DE TARJETA",
						"REPORTE DE AHORRO POR NEGOCIO",
						"REPORTE TARJETAS ENTREGADAS GENERAL",
						"REPORTE TARJETAS ENTREGADAS POR PUNTO DE ENTREGA",
					];
				}else{
					this.options = [
						"REPORTE GENERAL",
						"REPORTE DE VENTAS",
						"REPORTE POR PUNTO DE VENTA",
						"REPORTE GENERAL PARA NEGOCIOS",
						"REPORTE PARA NEGOCIOS",
						"REPORTE POR USO DE TARJETA",
						"REPORTE DE AHORRO POR NEGOCIO",
						"REPORTE TARJETAS ENTREGADAS GENERAL",
						"REPORTE TARJETAS ENTREGADAS POR PUNTO DE ENTREGA",
						"REPORTE TARJETAS ENTREGADAS POR COLONIA"
					];
				}
			}else {
				this.options = [
					"REPORTE GENERAL",
					"REPORTE DE VENTAS",
					"REPORTE POR PUNTO DE VENTA",
					"REPORTE GENERAL PARA NEGOCIOS",
					"REPORTE PARA NEGOCIOS",
					"REPORTE POR USO DE TARJETA",
					"REPORTE DE AHORRO POR NEGOCIO",
					"REPORTE TARJETAS ENTREGADAS GENERAL",
					"REPORTE TARJETAS ENTREGADAS POR PUNTO DE ENTREGA",
					"REPORTE TARJETAS ENTREGADAS POR COLONIA"
				];
			}
		},

		/**
		 * Search the table data with search input
		 */
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},

		todoFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.todoTotalRows = filteredItems.length;
			this.todocurrentPage = 1;
		},

		getColor (estado) {
				if (estado == "Activo") return 'red'
				else return 'green'
			},

		handleInput(value, data) {
			this.editableDataItems[data.index][data.field.key] = value;
		},

		selectChange(){
			this.tableReports = [];
			this.negocioSelected = '';
			this.puntoSelected = '';
			this.municipioSelected = '';
			const get = getReport(this.reporte);
			this.getObject = get;
			this.municipioSelect = this.getObject.municipioSelect;
			this.negocioSelect = this.getObject.negocioSelect;
			this.puntoSelect = this.getObject.puntoSelect;
			if (this.negocioSelect) {
				if (this.permit  === 'gerente'){
					this.negocioSelect = false;
					// this.negocioSelected = this.id_negocio;
					this.fetchPuntosVenta(this.id_negocio);
				}else{
					this.fetchPuntosVenta();
				}
			}
			if (this.municipioSelect) {
				this.fetchMunicipios();
			}
		},
		handleSearch(){
			this.isLoading = true;
			const fecha_inicio = this.daterange[0] ? moment(this.daterange[0]).format('YYYY-MM-DD') : '';
			const fecha_fin = this.daterange[1] ? moment(this.daterange[1]).format('YYYY-MM-DD') : '';
			const id_punto_venta = this.puntoSelected;
			const id_negocio = this.negocioSelected;
			const id_municipio = this.municipioSelected;
			const id_empresa = this.id_empresa;
			const data_user = JSON.parse(localStorage.getItem("user"));
			const id_municipio_usuario =  data_user.id_user_municipio;
			console.log(id_municipio_usuario);
			const get = getReport(this.reporte,fecha_inicio,fecha_fin,id_punto_venta,id_negocio,id_municipio,this.permit,id_empresa,id_municipio_usuario);
			this.getObject = get;
			this.itemsTable = this.getObject.Items;
			this.url = this.getObject.url;
			this.urlDownload = this.getObject.urlDownload;
			this.negocioSelect = this.getObject.negocioSelect;
			this.puntoSelect = this.getObject.puntoSelect;
			this.municipioSelect = this.getObject.municipioSelect;
			if (this.url !== '') {
				this.fetchTable();
			}
		},
		fetchTable(){
			const config = {
				method: 'get',
				url: `${this.url}`,
				headers: { 
					'Authorization': `${this.token}`
				}
			};
			this.isLoading = true;
			axios(config).then((res) =>{
				const {response="",data=[]} = res.data;
				if (response === true) {
					this.tableReports = data;
				}
				this.isLoading = false;
			}).catch(err => {
				this.isLoading = false;
				console.log(err);
				const {response=""} = err.response.data;
				if (response === false) {
					this.tableReports = [];
				}
			})
			
		},

		fetchPuntosVenta(id_negocio=""){
			this.isLoading = true;
			axios.get(`/puntos_venta?id_negocio=${id_negocio}`)
			.then((res) => {
				const {response="", data=[]} = res.data;
				if (response === true) {
					if (this.permit === 'gerente') {
						this.puntos = data;
					} else {
						this.negocios = data;
					}
					// this.puntos = data;
				}
				this.isLoading = false;
			})
			.catch(err => {
				this.isLoading = false;
				const {response="",details } = err.response.data;
				if (response === false) {
					console.log(details);
				}
			})
		},

		fetchMunicipios(){
			this.isLoading = true;
			axios.get('/municipios')
			.then((res) => {
				const {response="", data=[]} = res.data;
				if (response === true) {
					this.municipios = data;
				}
				this.isLoading = false;
			})
			.catch(err => {
				this.isLoading = false;
				const {response="",details } = err.response.data;
				if (response === false) {
					console.log(details);
				}
			})
		},

		changeNegocio(){
			const select = this.puntoSelect;
			if (select) {
				this.isLoading = true;
				const id_negocio = this.negocioSelected;
				if (id_negocio !== '') {
					axios.get(`/puntos_venta?id_negocio=${id_negocio}`)
					.then((res) => {
						const {response="", data=[]} = res.data;
						this.isLoading = false;
						if (response === true) {
							this.puntos = data;
						}
						this.isLoading = false;
					})
					.catch(err => {
						const {response="",details } = err.response.data;
						this.isLoading = false;
						if (response === false) {
							console.log(details);
							this.puntos = [];
						}
						this.isLoading = false;
					})
				}
			}
		},

		getName(){
			const name = this.reporte;
			const date = moment().format('YYYY-MM-DD');
			let result = '';
			switch (name) {
				case 'REPORTE GENERAL':
					result = `ReporteGeneral_${date}`;
					break;
				case 'REPORTE DE VENTAS':
					result = `ReporteVentas_${date}`;
					break;
				case 'REPORTE POR PUNTO DE VENTA':
					result = `ReportePV_${date}`;
					break;
				case 'REPORTE GENERAL PARA NEGOCIOS':
					result = `ReporteGNegocios_${date}`;
					break;
				case 'REPORTE PARA NEGOCIOS':
					result = `ReporteNegocios_${date}`;
					break;
				case 'REPORTE POR USO DE TARJETA':
					result = `ReporteUTarjeta_${date}`;
					break;
				case 'REPORTE DE AHORRO POR NEGOCIO':
					result = `ReporteANegocio_${date}`;
					break;
				case 'REPORTE TARJETAS ENTREGADAS GENERAL':
					result = `TarjetasEntregadas_${date}`;
					break;
				case 'REPORTE TARJETAS ENTREGADAS POR PUNTO DE ENTREGA':
					result = `TEntregadasXPV_${date}`;
					break;
				case 'REPORTE TARJETAS ENTREGADAS POR COLONIA':
					result = `TEntragadasXColoni_${date}`;
					break;
			}
			return result;
		},

		async exportTable() {
			if(this.tableReports.length > 0) {
				if(this.reporte == 'REPORTE GENERAL') {
					
					this.isLoading = true;
					// console.log('aqui');
					
					const res = await fetch(this.urlDownload, {method: 'GET'});
					
					const now = await moment().format('YYYY-MM-DD_HH:mm:ss');
					let fileName = 'reporte';
					if(this.reporte === 'REPORTE GENERAL'){
						fileName = `reporte_general_${now}.csv`;
					}else{
						fileName = `reporte_negocios_${now}.csv`;
					}

					const blob = await res.blob();
					const newBlob = await new Blob([blob]);

					const blobUrl = await window.URL.createObjectURL(newBlob);

					const link = await document.createElement('a');
					link.href = blobUrl;
					link.setAttribute('download', `${fileName}`);
					document.body.appendChild(link);
					link.click();
					link.parentNode.removeChild(link);
					this.isLoading = false;
					// clean up Url
					window.URL.revokeObjectURL(blobUrl);
				} else {
					// console.log('aca');
					const data = XLSX.utils.json_to_sheet(this.tableReports);
					const workbook = XLSX.utils.book_new();
					const filename = this.getName();
					XLSX.utils.book_append_sheet(workbook, data, filename);
					XLSX.writeFile(workbook, `${filename}.xlsx`);
				}
			} else this.$swal("Aviso", "No hay datos que exportar","warning");
    },
	},


};
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />	
		<div class="row">
			<div class="col-lg-12">
				<v-card>
					<div class="card-body">
						<div class="row mt-4">
							<div class="col-sm-12 col-md-6">
								<h4 class="card-title mb-4">Lista de Reportes</h4>
							</div>
							<div class="col-sm-12 col-md-6  text-md-end">
								<v-btn depressed color="primary" type="button" id="button-addon2" @click="exportTable()" :disabled="isLoading">
									Exportar Excel
								</v-btn>
							</div>
						</div>
						<div class="row mt-4">
							<div class="col-sm-12 col-md-3">
								<b><label class="form-check-label">Tipo de Reporte</label></b>
								<div class="mb-4">
									<b-form-select
										class="form-select"
										v-model="reporte"
										size="lg"
										@change="selectChange()"
									>
										<option 
											v-for="option in options" 
											:key="option.index" 
											:value="option"
											>{{option}}
										</option>
									</b-form-select>
								</div>
							</div> 
							<div  v-if="negocioSelect" class="col-sm-12 col-md-3" >
								<b><label class="form-check-label">Negocio</label></b>
								<div class="mb-4">
									<b-form-select
										class="form-select"
										v-model="negocioSelected"
										size="lg"
										@change="changeNegocio()"
									>
										<option 
											v-for="negocio in negocios" 
											:key="negocio.id_negocio" 
											:value="negocio.id_negocio"
											>{{negocio.nombre}}
										</option>
									</b-form-select>
								</div>
							</div> 
							<div  v-if="puntoSelect" class="col-sm-12 col-md-3" >
								<b><label class="form-check-label">Punto de venta</label></b>
								<div class="mb-4">
									<b-form-select
										class="form-select"
										v-model="puntoSelected"
										size="lg"
									>
										<option 
											v-for="punto in puntos" 
											:key="punto.id_punto_venta" 
											:value="punto.id_punto_venta"
											>{{punto.nombre}}
										</option>
									</b-form-select>
								</div>
							</div> 
							<div  v-if="municipioSelect" class="col-sm-12 col-md-3" >
								<b><label class="form-check-label">Municipio</label></b>
								<div class="mb-4">
									<b-form-select
										class="form-select"
										v-model="municipioSelected"
										size="lg"
									>
										<option 
											v-for="muni in municipios" 
											:key="muni.id_municipio" 
											:value="muni.id_municipio"
											>{{muni.nombre}}
										</option>
									</b-form-select>
								</div>
							</div> 
							<div class="col-sm-12 col-md-3">
								<b><label class="form-check-label">Periodo de búsqueda</label></b>
									<div class="mb-4">
										<date-picker v-model="daterange" range append-to-body lang="es" confirm></date-picker>
									</div>
							</div>
						</div>  
						<div class="row my-4">
							<div class="col-sm-12 col-md-12" style="text-align:center;">
								<v-btn
									color="primary"
									type="button"
									:disabled="isLoading"
									v-on:click="handleSearch();"
								>
									Generar
								</v-btn>
							</div>
						</div>
						<div class="d-flex justify-content-center" v-if="isLoading">
							<b-spinner variant="primary" label="Spinning"></b-spinner>
						</div>
						<!-- tableReports table -->
						<tableReports
							v-else
							:tableReports="tableReports"
							:itemsTable="itemsTable"
							:updating="fetchingStats"
							responsive="sm"
							:per-page="perPage"
							:current-page="currentPage"
							:sort-by.sync="sortBy"
							:sort-desc.sync="sortDesc"
							:filter="filter"
							:filter-included-fields="filterOn"
							@filtered="onFiltered"
						/>
					</div>
					<!-- <div class="row mt-4">
						<div class="col-sm-12 col-md-6">
							<v-divider
								class="mx-2"
								inset
								vertical
							></v-divider>
								Mostrando {{currentPage}} de {{totalRows}}  registros
						</div>
						<div class="col-sm-12 col-md-6 text-md-end">
							<b-pagination
								v-model="currentPage"
								:total-rows="rows"
								:per-page="perPage"
								first-text="Primera"
								prev-text="Anterior"
								next-text="Siguiente"
								last-text="Última"
							></b-pagination>
						</div>
					</div> -->
				</v-card>
			</div>
			<!-- end col -->
		</div>
		<!-- end row -->
	</Layout>
</template>
